<template>
  <div v-if="product.productId">
    <q-item
      :key="product.productId"
      clickable
      class="q-px-none q-py-xs bg-white"
    >
      <q-item-section avatar top class="justify-start q-pr-sm q-mr-xs">
        <q-img
          :src="
            $ossLimit(
              product.image ||
                'https://static.bakmigm.co.id/menu/00110000/Default.jpg',
              60,
            )
          "
          :ratio="1"
          class="border-radius-8 img-card"
          style="width: 56px; height: 56px"
        />
      </q-item-section>
      <q-item-section top>
        <q-item-label bold class="font-size-16 break-word">
          {{ product.productName }}
        </q-item-label>
        <q-item-label v-if="product.modifiers?.length" caption>
          <template v-for="(opti, index) in product.modifiers">
            <span :key="opti.name" class="break-word">
              {{ opti.name }}
              <span v-if="index !== product.modifiers?.length - 1">/</span>
            </span>
          </template>
        </q-item-label>
        <q-item-label v-if="product.addons?.length" caption>
          <div
            v-for="addon in product.addons"
            :key="addon.externalProductId"
            class="break-word"
          >
            {{ addon.name }} x{{ addon.quantity }} {{ $pid(addon.totalPrice) }}
          </div>
        </q-item-label>

        <q-item-label
          class="font-size-12 flex justify-between items-center q-mt-sm"
        >
          <span
            class="text-theme-gray"
            style="word-wrap: break-word; width: 100%"
          >
            {{ product.comment }}
          </span>
        </q-item-label>
        <q-item-label
          class="font-size-12 flex justify-between items-center q-mt-sm"
        >
          <span class="text-theme-gray">x{{ product.quantity }}</span>
        </q-item-label>
      </q-item-section>
      <q-item-section class="price-box">
        <span class="price">
          {{ $n(price, 'currency', 'id-ID') }}
        </span>
        <span v-if="price !== delPrice" class="del">
          {{ $n(delPrice, 'currency', 'id-ID') }}
        </span>
      </q-item-section>
    </q-item>
    <slot name="pkg" />
  </div>
</template>

<script setup>
import { ref, defineProps, computed } from 'vue';
import { useProductPrice } from 'src/utils/hooks/product/use-product-price';

const props = defineProps({
  product: {
    type: Object,
    default: () => ({}),
  },
});
const _prod = computed(() => props.product);
const { delPrice, price } = useProductPrice(_prod);
</script>

<style lang="scss" scoped>
.q-img[lazy='loading'] {
  /*your style here*/
  background-image: url('../../../assets/loading/loading.gif');
  background-size: auto;
  background-repeat: no-repeat;
  background-position: center;
}
.img-card {
  background-size: cover;
}
.break-word {
  word-break: break-word;
}
.price-box {
  margin-left: auto;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  align-self: flex-start;
  flex: initial;
  .del {
    text-decoration: line-through;
    color: $grayFont;
  }
}
</style>
